/**
 *
 * Usage:
 *
 * var someVar = 'Hello world';
 *
 *  public stringJSPipeArgs = {
 *        toCurrency: ['us']
 *   };
 *
 *  public stringJSPipeArgs = {
        padLeft: [20,'LEFT'],
        padRight: [50,'RIGHT'],
        toDateFromTimestamp: []
        humanize: [],
        replaceAll: ['customers','Sean']
    }
 *
 * <h5>{{someVar | StringJSV2Pipe:stringJSPipeArgs}}</h5>
 *
 * ================================================================================================
 *
 * <div *ngIf="someVar | StringJSV2Pipe:stringJSPipeArgs">SHOW ME IF END WITH world</div>
 *
 * public stringJSPipeArgs = {
        endsWith: ['world']
    };

 * var someVar = 'Hello world';
 */


/** Sean, example of how to use Date / time pipe
 const timeNowEpoc = jsDateToEpoch(new Date()); // this is now
 const timeNowFormatted = moment.unix(timeNowEpoc).format('YYYY-MM-DD hh:mm:ss a'); // using moment directly
 const timeNowFormattedViaStringJS = this.stringJS.transform(String(timeNowEpoc), {toDateFromTimestamp: ['YYYY-MM-DD hh:mm:ss a', 0]}); // using stringJS
 console.log(timeNowEpoc, timeNowFormatted, timeNowFormattedViaStringJS);

 using pipe:
 ...
 <span> {{conv.time | StringJSV2Pipe:stringJSPipeArgs}} </span>
 ...
 public stringJSPipeArgs = { toDateFromTimestamp: ['YYYY-MM-DD hh:mm:ss a', 0] };
 **/


import {
    Pipe,
    PipeTransform
} from '@angular/core';
import { toCurrency, toDateFromTimestamp } from '../common';

@Pipe({
    name: 'StringJSV2Pipe',
    pure: true
})
export class StringJSV2Pipe implements PipeTransform {
    transform(input: string, ...args: any[]): any {
        if (!input) return;

        const execs = args[0];
        input = String(input);

        for (const methodName in execs) {
            const params = execs[methodName];

            if (methodName === 'toDateFromTimestamp') {
                return toDateFromTimestamp(input, params);

            } else if (methodName === 'toCurrency') {
                return toCurrency(input, params);
            }

            input = S(input)[methodName](...params);
            if (input['s']) {
                input = input['s'];
            }
        }
        return input;
    }
}
